import { Alert, Button } from '@mui/material'
import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { Page } from '../../components'
import { CannedJobFees } from '../../components/CannedJobs/CannedJobFees'
import { CannedJobForm } from '../../components/CannedJobs/CannedJobForm/CannedJobForm'
import { CannedJobLabor } from '../../components/CannedJobs/CannedJobLabor'
import { CannedJobParts } from '../../components/CannedJobs/CannedJobParts'
import { OutlinedBox } from '../../components/SharedUI'
import { LoadingBackdrop } from '../../components/SharedUI/LoadingBackdrop'
import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { AppRoutes } from '../../models'
import { useGetCannedJobExpandedQuery } from '../../redux/api/cannedJobApi'
import { CannedJobDetailContent } from './CannedJobDetailContent'

export default function NewCannedJobPage() {
  const navigate = useNavigate()
  const [id, setId] = useState('')
  const { accessToken, shopId } = useAccessTokenAndShopId()

  const { data: cannedJobs } = useGetCannedJobExpandedQuery(
    {
      authorization: accessToken,
      shop: shopId,
      cannedJobs: [id!]
    },
    { skip: !id }
  )
  const cannedJob = useMemo(
    () => (cannedJobs ? cannedJobs[0] : undefined),
    [cannedJobs]
  )
  return (
    <Page title={'New Canned Job'}>
      <Button
        onClick={() =>
          navigate(AppRoutes.SETTINGS_CANNED_JOBS)
        }>{`< Back`}</Button>
      <OutlinedBox title={'New Canned Job'}>
        {id && !cannedJob && <LoadingBackdrop />}
        {!cannedJob ? (
          <>
            <CannedJobForm
              submitCallback={(jobId) => setId(jobId)}
              cancelCallback={() => navigate(AppRoutes.SETTINGS_CANNED_JOBS)}
            />
            <Alert severity={'info'}>
              Please save the canned job before adding labor, parts, and fees.
            </Alert>
            <CannedJobLabor
              customLabors={[]}
              motorLabors={[]}
              disabled
              id={''}
            />
            <CannedJobParts
              customParts={[]}
              partLookups={[]}
              inventoryParts={[]}
              idToInventoryParts={{}}
              inventoryProducts={[]}
              idToInventoryProducts={{}}
              motorFluids={[]}
              disabled
              id={''}
            />
            <CannedJobFees fees={[]} disabled id={''} />
          </>
        ) : (
          <CannedJobDetailContent cannedJob={cannedJob} />
        )}
      </OutlinedBox>
    </Page>
  )
}
